import React from 'react';
import {
  AppBar,
  Container,
  fade,
  Toolbar,
  Typography,
} from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import AppVersion from './AppVersion';

const styles = (theme) => ({
  appBar: {
    background: `linear-gradient(
      180deg,
      ${fade(theme.palette.primary.main, 0.75)} 0%,
      ${theme.palette.primary.main} 70%,
      ${fade(theme.palette.primary.main, 0.95)} 100%
    )`,
    borderTop: `1px solid ${fade('#000', 0.08)}`,
    boxShadow: '0 -6px 20px rgba(0,0,0,0.10)',
    zIndex: 49,
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    minHeight: 48,
    paddingLeft: 0,
    paddingRight: 0,
    [theme.breakpoints.down('sm')]: {
      minHeight: 40,
      paddingTop: 6,
      paddingBottom: 6,
    },
  },
  copyrightWrap: {
    flex: 1,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  versionWrap: {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  copyright: {
    color: theme.palette.text.main,
    whiteSpace: 'nowrap',
    fontSize: 14,
  },
  linksContainer: {
    display: 'flex',
    gap: 16,
    flexWrap: 'wrap',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'nowrap',
      justifyContent: 'flex-start',
      overflowX: 'auto',
      WebkitOverflowScrolling: 'touch',
      width: '100%',
      minWidth: 0,
      gap: 12,
      paddingBottom: 2,
      scrollbarWidth: 'thin',
    },
  },
  link: {
    color: theme.palette.text.main,
    opacity: 0.9,
    textDecoration: 'none',
    transition: 'opacity 0.2s ease',
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      whiteSpace: 'nowrap',
    },
    '&:hover': {
      opacity: 1,
      textDecoration: 'underline',
    },
  },
});

function Footer({ classes }) {
  const segnalazioniLink = process.env.REACT_APP_SEGNALAZIONI_LINK;

  return (
    <AppBar position="static" className={classes.appBar}>
      <Container>
        <Toolbar className={classes.toolbar}>
          <div className={classes.copyrightWrap}>
            <Typography className={classes.copyright}>
              Copyright© BIORSAF SRL Innovativa
            </Typography>
          </div>
          <div className={classes.linksContainer}>
            <a
              href="https://bsfood.biorsaf.it/termini_uso_bs-safe.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className={classes.link}
            >
              Condizioni D'uso
            </a>
            <a
              href="https://bsfood.biorsaf.it/privacy_policy_bs-safe.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className={classes.link}
            >
              Privacy Policy
            </a>
            <a
              href="https://biorsaf.it/cookie-policy/"
              target="_blank"
              rel="noopener noreferrer"
              className={classes.link}
            >
              Cookie Policy
            </a>
            <a
              href="https://bsfood.biorsaf.it/Utilizzo-pannello-di-controllo-BSFOOD.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className={classes.link}
            >
              Guida Piattaforma
            </a>
            <a
              href={segnalazioniLink}
              // href="https://bit.ly/bs-food-tickets"
              target="_blank"
              rel="noopener noreferrer"
              className={classes.link}
            >
              Segnalazioni
            </a>
          </div>
          <div className={classes.versionWrap}>
            <AppVersion />
          </div>
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default withStyles(styles)(Footer);
